<div class="ac-result">
  <div class="ac-header">
    <span class="ac-total"
      >{{ count() | number }}
      {{ 'ALERT_LIST.ALERT_CONFIGURATIONS' | translate }}</span
    >
    <div class="ac-header-actions">
      <button
        type="button"
        class="header-open-btn"
        [matTooltip]="
          'SEARCH_GLOBAL_MODAL.ALERT_CONFIGURATIONS.CREATE_ALERT' | translate
        "
        (click)="openAlertTemplates()"
      >
        <span class="ui-icon-plus"></span>
      </button>
      <button
        type="button"
        class="header-open-btn"
        [matTooltip]="
          'SEARCH_GLOBAL_MODAL.ALERT_CONFIGURATIONS.OPEN_ALERT_CONFIGURATIONS'
            | translate
        "
        (click)="openAlertConfigurationsPage()"
      >
        <span class="ui-icon-new-tab"></span>
      </button>
    </div>
  </div>

  <div class="ac-filters">
    <ui-search
      class="ac-search"
      [searchQuery]="searchQuery()"
      [placeholder]="'ALERT_LIST.SEARCH_PLACEHOLDER' | translate"
      (onInput)="onSearchQuery($event)"
    ></ui-search>

    <ui-camera-select-button
      class="ac-filter-control"
      [selectedCount]="selectedCameraList().length"
      (click)="openSelectCameraModal()"
    ></ui-camera-select-button>

    <div class="ac-filter-control ac-type-filter">
      <step-option-selector
        [multiple]="true"
        [asUiSelector]="true"
        [filterEnabled]="true"
        [optionsGroups]="alertTypeGroupsForSelector()"
        [stringOptions]="true"
        [optionsKeyValuePair]="alertTypeKeyValuePairs()"
        [panelClass]="'alert-type-selector alert-type-selector--wide'"
        [placeholder]="'MONITORING.PLACEHOLDERS.ALERT_TYPE'"
        [ngModel]="selectedFlowTypeKeys()"
        (ngModelChange)="onFlowTypesKeysChange($event)"
      ></step-option-selector>
    </div>

    <app-tag-filter
      class="ac-filter-control"
      [selectWidth]="'100%'"
      [formControl]="tagsFilterControl"
      [isCreateButtonVisibleSig]="false"
    ></app-tag-filter>
  </div>

  <div class="ac-chips" *ngIf="hasActiveFilters()">
    <ui-filter-chip
      *ngIf="searchQuery()"
      [title]="searchQuery()"
      (removeClicked)="onRemoveSearch()"
    ></ui-filter-chip>

    <ng-container *ngIf="selectedCameraList().length">
      <div [matMenuTriggerFor]="camerasMenu" class="ac-camera-chip">
        <ui-filter-chip
          [title]="
            selectedCameraList().length +
            ' ' +
            ('WALL_LIST.CAMERA_FILTER' | translate)
          "
          [allowDelete]="false"
        ></ui-filter-chip>
      </div>
      <mat-menu #camerasMenu="matMenu" xPosition="after" yPosition="below">
        <div class="ac-camera-menu">
          <ui-filter-chip
            *ngFor="let camera of selectedCameraList()"
            [title]="camerasEntities()[camera.cameraId]?.edgeOnly?.name"
            [allowDelete]="true"
            (removeClicked)="onRemoveCamera(camera.cameraId)"
          ></ui-filter-chip>
        </div>
      </mat-menu>
    </ng-container>

    <ui-filter-chip
      *ngFor="let flowType of selectedFlowTypes()"
      [title]="flowName(flowType.category, flowType.flowType) | translate"
      (removeClicked)="onRemoveFlowType(flowType)"
    ></ui-filter-chip>

    <ui-filter-chip
      *ngFor="let tagId of selectedTags()"
      [title]="tagEntities()[tagId]?.name"
      (removeClicked)="onRemoveTag(tagId)"
    ></ui-filter-chip>
  </div>

  <div class="ac-body">
    <div class="ac-filtering" *ngIf="isFiltering()">
      <ui-preloader
        [color]="PreloaderColor.blue"
        [diameter]="40"
      ></ui-preloader>
    </div>

    <ng-container *ngIf="!isFiltering()">
      <cdk-virtual-scroll-viewport
        class="ac-list"
        *ngIf="configs().length > 0; else emptyState"
        [itemSize]="70"
      >
        <div
          class="ac-row"
          *cdkVirtualFor="let config of configs(); trackBy: trackByConfigId"
          [class.disabled]="
            deletingId() === config._id || editingId() === config._id
          "
          role="button"
          tabindex="0"
          (click)="onRowClick(config)"
          (keydown.enter)="onRowClick(config)"
        >
          <!-- Enable / disable toggle -->
          <div class="ac-toggle" (click)="$event.stopPropagation()">
            <ui-toggle
              [value]="config.enabled"
              [disabled]="
                togglingId() === config._id || editingId() === config._id
              "
              [matTooltip]="
                (config.enabled
                  ? 'ALERT_LIST.DISABLE_ALERT'
                  : 'ALERT_LIST.ENABLE_ALERT'
                ) | translate
              "
              matTooltipClass="sidebar-tooltip"
              (change)="onToggle(config, $event)"
            ></ui-toggle>
          </div>

          <!-- Snapshot -->
          <event-camera-snapshot
            class="ac-snapshot"
            [formValue]="config.selectedFlow?.formValue"
            [zoneRegions]="config.zoneRegions"
            [zoneRegionCameras]="config.zoneRegionCameras"
          ></event-camera-snapshot>

          <!-- Name + sentence -->
          <div class="ac-info">
            <div class="ac-name" [title]="config.name">{{ config.name }}</div>
            <app-event-sentence-renderer
              [sentence]="config.sentence"
              [sentenceCameraInfo]="config.sentenceCameraInfo"
              [zoneRegions]="config.zoneRegions"
              [category]="config.selectedFlow?.category"
              [flowType]="config.selectedFlow?.flowType"
              [formValue]="config.selectedFlow?.formValue"
              [scheduleId]="config.selectedFlow?.scheduleId"
              [allBold]="true"
            ></app-event-sentence-renderer>
          </div>

          <!-- Sync status -->
          <app-status-chip
            class="ac-status"
            device="alert"
            iconClass="icon-20"
            [text]="false"
            [status]="statusFor(config)"
            (click)="$event.stopPropagation()"
          ></app-status-chip>

          <!-- Tags -->
          <div
            class="ac-tags"
            *ngIf="config.settings?.tags?.length"
            (click)="$event.stopPropagation()"
          >
            <tag-menu
              [tags]="config.settings.tags"
              [tooltip]="'DATABASE_TAGS.EVENT_TOOLTIP'"
            ></tag-menu>
          </div>

          <!-- Overlay menu -->
          <div class="ac-actions" (click)="$event.stopPropagation()">
            <ui-preloader
              *ngIf="
                deletingId() === config._id || editingId() === config._id;
                else menuTrigger
              "
              [diameter]="18"
              [color]="PreloaderColor.red"
            ></ui-preloader>
            <ng-template #menuTrigger>
              <span
                class="ui-icon-more-menu ac-menu-trigger"
                [matMenuTriggerFor]="rowMenu"
                [matTooltip]="'ALERT_LIST.MORE_ACTIONS' | translate"
                matTooltipClass="sidebar-tooltip"
              ></span>
            </ng-template>
            <mat-menu #rowMenu="matMenu" xPosition="before">
              <button mat-menu-item (click)="onEdit(config)">
                {{ 'COMMON.EDIT' | translate }}
              </button>
              <button
                mat-menu-item
                class="ac-delete-item"
                (click)="deleteConfig(config)"
              >
                {{ 'ALERT_LIST.DELETE_ALERT' | translate }}
              </button>
            </mat-menu>
          </div>
        </div>
      </cdk-virtual-scroll-viewport>

      <ng-template #emptyState>
        <div class="ac-empty">
          {{ 'ALERT_LIST.NO_ALERT_CONFIGURATIONS' | translate }}
        </div>
      </ng-template>
    </ng-container>
  </div>
</div>
